import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { saveSpotlightProduct } from "../../../../../Service/user";
import { toast } from "react-hot-toast";
import ThumbUpIcon from "../../../../../Images/Startup-Spotlight/ThumbUpIcon.png";
import RoastIcon from "../../../../../Images/Startup-Spotlight/RoastIcon.png";
import ShareIcon from "../../../../../Images/Startup-Spotlight/ShareIcon.png";
import SaveIcon from "../../../../../Images/Startup-Spotlight/SaveIcon.png";
import TagIcon from "../../../../../Images/Startup-Spotlight/TagIcon.png";
import SharePopup from "../../../../PopUp/SocialSharePopup/SharePopup";
import { FaGlobe, FaTwitter, FaLinkedin, FaInstagram, FaTags, FaArrowUp, FaArrowDown, FaThumbsUp, FaRegThumbsDown, FaAngry, FaGrinHearts } from "react-icons/fa";

import "./ProductDetails.scss";

const ProductDetails = ({ productData, onScrollToComments, onIncrementShareCount, onUpvote, onDownvote }) => {
	const [showSharePopup, setShowSharePopup] = useState(false);
	const [loading, setLoading] = useState(false);
	const [selectedImage, setSelectedImage] = useState(null);
	const [upvoteLoading, setUpvoteLoading] = useState(false);
	const [downvoteLoading, setDownvoteLoading] = useState(false);

	
	// Get logged in user ID from localStorage
	const loggedInUserId = JSON.parse(localStorage.getItem("loggedInUser"))?._id;
	
	// Check if user has upvoted or downvoted
	const hasUpvoted = Array.isArray(productData?.upvotes) && productData.upvotes.includes(loggedInUserId);
	const hasDownvoted = Array.isArray(productData?.downvotes) && productData.downvotes.includes(loggedInUserId);
	
	const handlesaveClick = async () => {
		try {
			setLoading(true);
			const response = await saveSpotlightProduct(productData._id);
			if (response.status === 200) {
				// toast.success("Product saved successfully!");
				toast.success(response.message);
			} else {
				toast.error("Failed to save product. Please try again.");
			}
		} catch (error) {
			console.error("Error saving product:", error);
			toast.error("Failed to save product. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	// Custom upvote handler with loading state
	const handleUpvoteWithLoading = async () => {
		setUpvoteLoading(true);
		try {
			await onUpvote();
		} finally {
			setUpvoteLoading(false);
		}
	};
	
	// Custom downvote handler with loading state
	const handleDownvoteWithLoading = async () => {
		setDownvoteLoading(true);
		try {
			await onDownvote();
		} finally {
			setDownvoteLoading(false);
		}
	};

	// Handle share button click - always show popup regardless of login status
	const handleShareClick = () => {
		setShowSharePopup(true);
		// Only increment share count if the function is available and user is logged in
		if (onIncrementShareCount && loggedInUserId) {
			onIncrementShareCount(productData._id);
		}
	};

	const openImageModal = (image) => {
		setSelectedImage(image);
	};

	const closeImageModal = () => {
		setSelectedImage(null);
	};

	return (
		<>
			<div className="product-details">
				<div className="product-info">
					<div className="product-details-container">
						<div className="product-header">
							<div className="product-logo-title">
								<div className="product-logo">
									<img
										src={productData?.logo || "/placeholder.svg"}
										alt={productData?.title}
									/>
								</div>
								<div className="title-tagline">
									<h2>{productData?.title}</h2>
									{productData.tagline && (
										<p className="product-tagline">{productData.tagline}</p>
									)}
								</div>
							</div>

							<div className="pd-action-buttons">
								<button 
									className={`vote-button upvote-button ${hasUpvoted ? 'voted' : ''}`} 
									onClick={handleUpvoteWithLoading}
									title={hasUpvoted ? "Upvoted" : "Upvote"}
									disabled={upvoteLoading || downvoteLoading}
								>
									{upvoteLoading ? (
										<span className="spinner small"></span>
									) : (
										<>
											<FaArrowUp className="vote-icon" />
											{hasUpvoted ? (
												<>
													Upvoted
												</>
											) : (
												"Upvote"
											)}
										</>
									)}
								</button>
								<button 
									className={`vote-button downvote-button ${hasDownvoted ? 'voted' : ''}`} 
									onClick={handleDownvoteWithLoading}
									title={hasDownvoted ? "Downvoted" : "Downvote"}
									disabled={upvoteLoading || downvoteLoading}
								>
									{downvoteLoading ? (
										<span className="spinner small"></span>
									) : (
										<>
											<FaArrowDown className="vote-icon" />
											{hasDownvoted ? (
												<>
													Downvoted
												</>
											) : (
												"Downvote"
											)}
										</>
									)}
								</button>
								<button
									className="share-button"
									onClick={handleShareClick}
								>
									<img src={ShareIcon} className="toolbarIcon" alt="" />
								</button>
								<button className="bookmark-button" onClick={handlesaveClick}>
									{loading ? (
										<span className="spinner small"></span>
									) : (
										<img src={SaveIcon} className="toolbarIcon" alt="" />
									)}
								</button>
							</div>
						</div>

						<div className="product-description">
							<h4 className="section-subtitle">About the Company</h4>
							<p>{productData?.aboutCompany}</p>
						</div>

						{/* Industry Information */}
						<div className="product-industry">
							<h4 className="section-subtitle"><FaTags className="section-icon" /> Industry</h4>
							<p>{productData?.industry || "Not specified"}</p>
						</div>

						{/* Pricing Information */}
						{/* <div className="product-pricing">
							<h4><FaDollarSign className="section-icon" /> Pricing Details</h4>
							<div className="pricing-plans">
								{productData?.pricing ? (
									<div className="pricing-plan">
										<p className="plan-name">{productData.pricing.name || "Standard Plan"}</p>
										<p className="plan-price">{productData.pricing.price || "Contact for pricing"}</p>
										<p className="plan-description">{productData.pricing.description || "No description available"}</p>
									</div>
								) : (
									<p>Pricing information not available</p>
								)}
							</div>
						</div> */}

						{/* Social Links */}
						<div className="social-links">
							<h4 className="section-subtitle">Connect With Us</h4>
							<div className="links-container">
								{productData?.socialLinks?.website && (
									<a href={productData.socialLinks.website} target="_blank" rel="noopener noreferrer" className="social-link website">
										<FaGlobe className="social-icon" />
										<span>Website</span>
									</a>
								)}
								{productData?.socialLinks?.twitter && (
									<a href={productData.socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="social-link twitter">
										<FaTwitter className="social-icon" />
										<span>Twitter</span>
									</a>
								)}
								{productData?.socialLinks?.linkedin && (
									<a href={productData.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social-link linkedin">
										<FaLinkedin className="social-icon" />
										<span>LinkedIn</span>
									</a>
								)}
								{productData?.socialLinks?.instagram && (
									<a href={productData.socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social-link instagram">
										<FaInstagram className="social-icon" />
										<span>Instagram</span>
									</a>
								)}
								{!productData?.socialLinks?.website && !productData?.socialLinks?.twitter && 
								 !productData?.socialLinks?.linkedin && !productData?.socialLinks?.instagram && (
									<p className="no-social-links">No social links available</p>
								)}
							</div>
						</div>

						<div className="tags">
							<span className="tags-label">Tags</span>
							<img src={TagIcon} className="tagIcon" alt="" />
							{productData?.tags?.map((tag, index) => (
								<span className="tag" key={index}>
									{tag}
								</span>
							))}
						</div>
					</div>

					{/* Comment Action Buttons */}
					<div className="comment-action-section">
						<div className="comment-action-heading">
							<h3>Share Your Thoughts</h3>
						</div>
						<div className="comment-action-buttons">
							<button 
								className="support-action-button" 
								onClick={() => {
									onScrollToComments();
								}}
							>
								<FaGrinHearts className="toolbarIcon" />
								Support this Product
							</button>
							<button 
								className="roast-action-button" 
								onClick={() => {
									onScrollToComments();
								}}
							>
								<FaAngry className="toolbarIcon" />
								Roast this Product
							</button>
						</div>
					</div>

					<div className="product-description-section">
						<h3>Core Value Propositions</h3>
						{Array.isArray(productData?.coreValueProposition) ? (
							<ol className="value-proposition-list">
								{productData.coreValueProposition.map((point, index) => (
									<li key={index}>
										<div className="proposition-content">{point}</div>
									</li>
								))}
							</ol>
						) : (
							<p>{productData?.coreValueProposition}</p>
						)}
					</div>

					<div className="founding-team">
						<h3>Founding Team</h3>
						<div className="team-members">
							{productData?.makers?.map((member, index) => (
								<div className="team-member" key={index}>
									<div className="member-photo">
										<img
											src={member.profilePicture || "/placeholder.svg"}
											alt={member.firstName}
										/>
									</div>
									<div className="member-info">
										<h4>
											{member.firstName} {member.lastName}
										</h4>
										<span className="years">{member.designation}</span>
										<p>{member.companyName}</p>
										<p>{member.bio}</p>
										{member.linkedin && (
											<a href={member.linkedin} className="linkedin-button">
												<svg
													xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 24 24"
												fill="currentColor"
											>
												<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
											</svg>
											LinkedIn
										</a>
										)}
									</div>
								</div>
							))}
						</div>
					</div>

					<div className="product-images">
						<h3>Product Images</h3>
						<div className="images-carousel">
							{productData?.productImages?.map((image, index) => (
								<img 
									src={image} 
									key={index} 
									alt="" 
									onClick={() => openImageModal(image)}
								/>
							))}
						</div>
					</div>
				</div>
			</div>

			{/* Image Modal */}
			{selectedImage && (
				<div className="image-modal" onClick={closeImageModal}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<button className="close-button" onClick={closeImageModal}>×</button>
						<img src={selectedImage} alt="Product" />
					</div>
				</div>
			)}

			{ReactDOM.createPortal(
				<SharePopup
					url={productData?.shareUrl}
					isOpen={showSharePopup}
					setIsOpen={() => setShowSharePopup(false)}
					isInvestor={false}
				/>,
				document.body
			)}
		</>
	);
};

export default ProductDetails;
